import L from "leaflet";

if (typeof window !== "undefined") window.L = L;
